import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { SelectKeysComponent } from '@popup/steem/pages/add-account/select-keys/select-keys.component';
import React from 'react';
import { connect } from 'react-redux';
import { PageTitleComponent } from 'src/common-ui/page-title/page-title.component';
import { Screen } from 'src/reference-data/screen.enum';
import { AddAccountMainComponent } from '../add-account-main/add-account-main.component';
import { AddByKeysComponent } from '../add-by-keys/add-by-keys.component';
import { ImportKeysComponent } from '../import-keys/import-keys.component';
const AddAccountRouter = ({ currentPage, titleProperties, hasTitle, navStack, }) => {
    const renderAccountPage = (page) => {
        switch (page) {
            case Screen.ACCOUNT_PAGE_INIT_ACCOUNT:
                return React.createElement(AddAccountMainComponent, null);
            case Screen.ACCOUNT_PAGE_ADD_BY_KEYS:
                return React.createElement(AddByKeysComponent, null);
            case Screen.ACCOUNT_PAGE_IMPORT_KEYS:
                return React.createElement(ImportKeysComponent, null);
            case Screen.ACCOUNT_PAGE_SELECT_KEYS:
                return React.createElement(SelectKeysComponent, null);
        }
    };
    return (React.createElement("div", { "data-testid": 'add-account-router-page', className: "add-account-router-page", style: {
            height: '100%',
            display: 'grid',
            gridTemplateRows: hasTitle &&
                navStack[navStack.length - 1].currentPage ===
                    Screen.ACCOUNT_PAGE_INIT_ACCOUNT
                ? '70px 1fr'
                : '1fr',
        } },
        hasTitle &&
            navStack[navStack.length - 1].currentPage ===
                Screen.ACCOUNT_PAGE_INIT_ACCOUNT && (React.createElement(PageTitleComponent, { title: titleProperties.title, titleParams: titleProperties.titleParams, skipTitleTranslation: titleProperties.skipTitleTranslation, isBackButtonEnabled: titleProperties.isBackButtonEnabled, isCloseButtonDisabled: titleProperties.isCloseButtonDisabled })),
        React.createElement("div", { className: "page-content", style: {
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
            } }, renderAccountPage(currentPage))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        currentPage: state.navigation.stack[0]
            ? state.navigation.stack[0].currentPage
            : Screen.UNDEFINED,
        params: state.navigation.stack[0] ? state.navigation.stack[0].params : {},
        hasTitle: ((_a = state.titleContainer) === null || _a === void 0 ? void 0 : _a.title.length) > 0,
        titleProperties: state.titleContainer,
        navStack: state.navigation.stack,
    };
};
const connector = connect(mapStateToProps, { navigateTo });
export const AddAccountRouterComponent = connector(AddAccountRouter);
